import athenaConfig from '../../../config';
import FactorsList from '../../../components/factor-list/FactorsList';
import AmplitudeUtils from '../../../utils/amplitude-utils';
import { toPascalCase } from '../../../utils/string-utils';
import FactorEnrollCustomizerBase from './base';
import { I18N_MAPPING } from '../../../constants';
import { launchedFromLwaProfile } from '../../../utils/lwa-profile-utils';
import { launchedFromAthenanetUserProfile } from '../../../utils/athenanet-user-profile-utils';

const { classic } = athenaConfig;

export default class FactorEnrollClassicCustomizer extends FactorEnrollCustomizerBase {
  alwaysDisplayBackToLogin = true;

  async shouldCustomize() {
    return (await super.shouldCustomize()) && classic;
  }

  async customize(): Promise<void> {
    if (launchedFromLwaProfile() || launchedFromAthenanetUserProfile()) {
      this.customizeForLwaProfile();
    }
    else {
      await super.customize();
    }
  }

  forgifyFactors() {
    const oktaComponent = jQueryCourage('.enroll-factor-list');
    AmplitudeUtils.logCustomEvent('AthenanetMFAPrompt', {});

    if (oktaComponent.length === 2) {
      const enrolledFactors = oktaComponent.eq(0);
      const pendingEnrollFactors = oktaComponent.eq(1);

      const enrolledFactorsForgeComponent = (
        <FactorsList
          oktaFactorsList={enrolledFactors.find('.enroll-factor-row')}
          isEnrolledFactor={true}
          title={I18N_MAPPING['en']['enroll.choices.list.enrolled']}
        />
      );

      this.renderForgeAndHideOktaComponent({
        id: `${pendingEnrollFactors.attr('class')!}-enrolled`,
        oktaComponent: enrolledFactors,
        forgeComponent: enrolledFactorsForgeComponent,
      });
      const pendingEnrollFactorsForgeComponent = (
        <FactorsList
          oktaFactorsList={pendingEnrollFactors.find('.enroll-factor-row')}
          title={I18N_MAPPING['en']['enroll.choices.list.optional']}
        />
      );
      this.renderForgeAndHideOktaComponent({
        id: pendingEnrollFactors.attr('class')!,
        oktaComponent: pendingEnrollFactors,
        forgeComponent: pendingEnrollFactorsForgeComponent,
      });
    }
    else {
      const enrolledFactors = oktaComponent;
      const enrolledFactorsForgeComponent = (
        <FactorsList oktaFactorsList={enrolledFactors.find('.enroll-factor-row')} />
      );
      this.renderForgeAndHideOktaComponent({
        id: enrolledFactors.attr('class')!,
        oktaComponent: oktaComponent,
        forgeComponent: enrolledFactorsForgeComponent,
      });
    }
  }

  protected primaryButtonOnClick = (buttonText?: string) => {
    buttonText = buttonText ? toPascalCase(buttonText) : 'Finish';
    AmplitudeUtils.logMfaEnrollEvent(`${buttonText}ButtonClick`);
  };

  private customizeForLwaProfile() {
    jQueryCourage('.auth-content').css('opacity', '0');
    jQueryCourage('.enroll-factor-button .button').eq(0)
      .trigger('click');
  }
}
